import { routes } from './routes';
import { LINE_ADD_FRIEND_BASE_URL } from './url';
import TEXT_STRING from './string';
// import ChargePoint from '../assets/images/chargePoint.png';

const storageKeys = {
  ACCESS_TOKEN: 'access_token',
  CLIENT_ID: 'client_id',
  USER_ID: 'user_id',
  PUBNUB_SYSTEM_BACKEND_ID: 'pubnub_system_backend_id',
};

const COOKIE_KEYS = {
  CLIENT_ID: 'client_id',
};

const queryKeys = {
  ADMIN_LIST: 'admin_list',
  CHANNEL_DETAIL: 'channel_detail',
  CHANNEL_LIST: 'channel_list',
  CHECK_AUTHENTICATION: 'check_authentication',
  CLIENT_CHANNEL_DETAIL: 'client_channel_detail',
  CLIENT_CHANNEL_LIST: 'client_channel_list',
  CURRENT_USER: 'CurrentUser',
  FCM_TOKEN: 'fcm_token',
  LINE_CHANNEL_STATUS: 'line_channel_status',
  MESSAGE_LIST: 'message_list',
  UNREAD_COUNT: 'unread_count',
};

const IMAGE_ACCEPTED = [
  'image/png',
  'image/jpeg',
  'image/apng',
  'image/avif',
  'image/gif',
  'image/svg+xml',
  'image/webp',
];
// チャットに届くPDF添付の判定に使う（management 側の送信と対になる）
const PDF_MIME_TYPE = 'application/pdf';
// 管理画面から届く ZIP 添付の判定用（受信・ダウンロードのみ。male からの送信は許可しない）
const ZIP_MIME_TYPE = 'application/zip';
const MESSAGE_SIZE = 25;
const DEBOUNCE_SEND_MESSAGE_ACTIVE = 1500;
const ONE_MB = 1024 * 1000;
const MAX_FILE_SIZE_PUBNUB = ONE_MB * 5; // 5MB

const SIGNAL_EVENT = {
  TYPING_ON: 'TYPING_ON',
  TYPING_OFF: 'TYPING_OFF',
  DISBAND_MEMBER: 'DISBAND_MEMBER',
  RECALL_MESSAGE: 'RECALL_MESSAGE',
  DELETE_MESSAGE: 'RECALL_MESSAGE',
};

const ERROR_CODE = {
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  NOT_IMPLEMENTED: 501,
  NOT_ACCEPTABLE: 406,
  REQUEST_TIMEOUT: 408,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  PAYLOAD_TOO_LARGE: 413,
  UNSUPPORTED_MEDIA_TYPE: 415,
  REQUESTED_RANGE_NOT_SATISFIABLE: 416,
  FAILED_DEPENDENCY: 424,
  LOCKED: 423,
  METHOD_NOT_ALLOWED: 405,
  PRECONDITION_REQUIRED: 428,
  URI_TOO_LONG: 414,
  NETWORK_AUTHENTICATION_REQUIRED: 511,
};

export {
  routes,
  storageKeys,
  queryKeys,
  TEXT_STRING,
  IMAGE_ACCEPTED,
  PDF_MIME_TYPE,
  ZIP_MIME_TYPE,
  MESSAGE_SIZE,
  SIGNAL_EVENT,
  ERROR_CODE,
  DEBOUNCE_SEND_MESSAGE_ACTIVE,
  MAX_FILE_SIZE_PUBNUB,
  ONE_MB,
  COOKIE_KEYS,
  LINE_ADD_FRIEND_BASE_URL
};
